import CommonModule from '@/modules/common/index.module'
import LearningModule from '@/modules/learning/index.module'
import Container from 'typedi'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        ...Container.get(CommonModule).store(),
        ...Container.get(LearningModule).store()
    }
})
